<template>
  <b-row>
    <b-col sm="12">
      <b-card body-class="py-2">
        <section class="list-view-heading">
          <ModuleViewHeading
            :module-id="access.module_id"
            :profile-id="access.profile_id"
            :reference="access.view_reference"
            summary-only
          />
          <div class="list-view-heading__controls">
            <div class="list-view-heading__actions">
              <TabHeaderActions />
            </div>
            <div class="list-view-heading__controls-end">
              <b-button variant="link" class="list-view-icon-btn" :class="{ 'list-view-icon-btn--active': filtersOpen }"
                        v-b-tooltip.hover.bottom :title="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        :aria-label="filtersOpen ? 'Ocultar filtros' : 'Mostrar filtros'"
                        @click="filtersOpen = !filtersOpen">
                <AppIcon name="filter" :fill="filtersOpen" />
              </b-button>
              <b-button variant="link" class="list-view-icon-btn list-view-icon-btn--primary"
                        v-b-tooltip.hover.bottom title="Agregar Zona" aria-label="Agregar Zona"
                        @click="add()">
                <AppIcon name="add" />
              </b-button>
            </div>
          </div>
        </section>

        <b-collapse v-model="filtersOpen">
          <div class="list-view-toolbar__filters">
            <div class="list-view-filter" style="width: 230px;">
              <label class="filter-label">Nombre</label>
              <b-form-input type="text" size="sm" placeholder="Ingrese el nombre de la zona" v-model="filters.name"></b-form-input>
            </div>
            <div class="list-view-filter" style="flex: 1 1 230px; max-width: 300px;">
              <label class="filter-label">Vendedores</label>
              <v-select :options="arr.filters.sellers" v-model="filters.sellers" placeholder="Todos" :multiple="true" :select-on-tab="true"></v-select>
            </div>
            <div class="list-view-filter" style="flex: 1 1 190px; max-width: 220px;">
              <label class="filter-label">Estado Clientes</label>
              <v-select :options="arr.filters.withCustomer" v-model="filters.withCustomer" :clearable="false" :multiple="false" :select-on-tab="true"></v-select>
            </div>
            <b-button variant="outline-dark" size="sm" @click="load()" v-b-tooltip.hover title="Aplicar filtros" style="height: 31px; width: 31px; padding: 0; flex-shrink: 0;">
              <AppIcon name="filter" />
            </b-button>
          </div>
        </b-collapse>
      </b-card>

      <b-row>
        <b-col lg="12">
          <b-card>
            <b-table class="app-table"
                    ref="table"
                    responsive
                    :stacked="isMobileViewport ? 'md' : false"
                    sticky-header="60vh"
                    :hover="true"
                    :small="true"
                    :fixed="false"
                    :items="table.items"
                    :fields="table.fields"
                    :current-page="table.currentPage"
                    :per-page="table.perPage"
                    @row-clicked="onRowClicked"
                    :tbody-tr-class="rowClass"
                    :busy="table.isBusy"
                    v-if="table.items.length || table.isBusy">

                <template v-slot:table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Cargando...</strong>
                  </div>
                </template>

                <template v-slot:cell(id)="data">
                  <b>{{data.item.id}}</b>
                </template>

                <template v-slot:cell(sellers_id)="data">
                  <b-avatar :src="data.item.seller.staff.image" size="25px" v-if="data.item.seller.staff.image"></b-avatar>
                  <b-avatar v-else
                            size="25px"
                            :text="avatarFromName(data.item.seller.name).text"
                            :style="avatarFromName(data.item.seller.name).style"></b-avatar>
                  <b class="ml-1">{{data.item.seller.name}}</b>
                </template>

                <template v-slot:cell(observations)="data">
                  <span>
                    <AppIcon name="people" :font-scale="1.3" class="mr-1 align-middle" :class="data.item.customers_count ? 'text-success' : 'text-muted'" />
                    <b-badge :variant="data.item.customers_count ? 'success' : 'secondary'" pill>{{data.item.customers_count}}</b-badge>
                    <span class="ml-1 text-muted small">{{data.item.customers_count == 1 ? 'cliente' : 'clientes'}}</span>
                  </span>
                </template>

                <template v-slot:cell(f_action)="data">
                  <b-dropdown right
                              no-caret
                              size="sm"
                              variant="link"
                              boundary="window"
                              :toggle-class="isMobileViewport ? 'crud-zones-action-toggle-labeled' : 'app-table-action-toggle'"
                              :class="{ 'pull-right': !isMobileViewport }">
                    <template #button-content>
                      <AppIcon name="more_vert" :label="isMobileViewport ? 'Opciones' : 'Acciones'" :class="{ 'mr-1': isMobileViewport }" />
                      <span v-if="isMobileViewport">Opciones</span>
                    </template>
                    <b-dropdown-item @click="openSub(data.item)">
                      <AppIcon name="visibility" /> Visualizar
                    </b-dropdown-item>
                    <b-dropdown-header>Acciones</b-dropdown-header>
                    <b-dropdown-item @click="edit(data.item)">
                      <AppIcon name="edit" /> Editar
                    </b-dropdown-item>
                    <b-dropdown-item @click="remove(data.item)">
                      <AppIcon name="delete" class="text-danger" /> Eliminar
                    </b-dropdown-item>
                  </b-dropdown>
                </template>
            </b-table>
            <EmptyState v-else icon="location_on" title="No se encontraron zonas" description="Ajustá los filtros para ampliar la búsqueda, o agregá una zona nueva." />

            <div class="app-table-footer">
              <span class="list-view-toolbar__count" v-if="table.tablePaginate">{{ table.tablePaginate.total }} registros</span>
            </div>
          </b-card>
        </b-col>
      </b-row>

      <!-- DRAWER: detalle de la zona seleccionada -->
      <b-sidebar
          id="sidebar-zone-detail"
          v-model="detailDrawer"
          right
          shadow
          backdrop
          title="Detalle de la Zona"
          width="420px"
          @hidden="hideSub">
        <div class="list-view-drawer" v-if="itemSelected">
          <div class="list-view-drawer__header">
            <div class="list-view-drawer__title">
              <span class="list-view-drawer__code">#{{itemSelected.id}}</span>
              <div>{{itemSelected.name}}</div>
              <div class="list-view-drawer__meta" v-if="itemSelected.seller">
                Vendedor: {{itemSelected.seller.name}}
              </div>
            </div>
            <div class="list-view-drawer__nav">
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoPrevZone"
                        v-b-tooltip.hover
                        title="Zona anterior"
                        @click="goPrevZone()">
                <AppIcon name="chevron-up" />
              </b-button>
              <b-button size="sm"
                        variant="outline-secondary"
                        :disabled="!canGoNextZone"
                        v-b-tooltip.hover
                        title="Zona siguiente"
                        @click="goNextZone()">
                <AppIcon name="chevron-down" />
              </b-button>
            </div>
          </div>

          <div class="list-view-drawer__stats">
            <div class="list-view-drawer__stat">
              <span class="list-view-drawer__stat-label">Clientes</span>
              <span class="list-view-drawer__stat-value">{{tableSub.items.length}}</span>
            </div>
          </div>

          <div>
            <div class="list-view-drawer__section-title">
              <AppIcon name="people" /> Clientes
            </div>

            <b-button @click="addSub(itemSelected)" type="button" variant="outline-dark" size="sm" class="float-right ml-2 mb-2" v-b-tooltip.hover title="Agregar Cliente a la Zona">
              <AppIcon name="add" /> Agregar
            </b-button>

            <b-table class="app-table app-table--compact"
                responsive
                :stacked="isMobileViewport ? 'md' : false"
                :hover="true"
                :small="true"
                :fixed="false"
                :items="tableSub.items"
                :fields="tableSub.fields"
                v-if="tableSub.items.length">

              <template v-slot:cell(id)="data">
                <b>{{data.item.customer.id}}</b>
              </template>

              <template v-slot:cell(code)="data">
                <b>{{data.item.customer.code}}</b>
              </template>

              <template v-slot:cell(customers_id)="data">
                <b-avatar :src="data.item.customer.image" size="25px" v-if="data.item.customer.image"></b-avatar>
                <b-avatar v-else
                          size="25px"
                          :text="avatarFromName(data.item.customer.name).text"
                          :style="avatarFromName(data.item.customer.name).style"></b-avatar>
                <b class="ml-1">{{data.item.customer.name}}</b>
                <AppIcon name="circle-fill" fill v-if="!data.item.customer.active" class="ml-2 text-danger" v-b-tooltip.hover title="Cliente INACTIVO" />
              </template>

              <template v-slot:cell(f_action)="data">
                <b-button size="sm"
                          variant="link"
                          class="app-table-icon-btn app-table-icon-btn--danger"
                          :class="{ 'app-table-icon-btn--labeled': isMobileViewport }"
                          v-b-tooltip.hover.left
                          title="Quitar cliente de la zona"
                          @click="removeSub(data.item)">
                  <AppIcon name="delete" label="Quitar cliente de la zona" font-scale="1.4" />
                  <span v-if="isMobileViewport" class="ml-1">Quitar</span>
                </b-button>
              </template>
            </b-table>
            <EmptyState v-else icon="people" title="Sin clientes asignados" />
          </div>

          <div class="list-view-drawer__actions">
            <b-button size="sm" variant="outline-secondary" @click="edit(itemSelected)">
              <AppIcon name="edit" class="mr-1" /> Editar
            </b-button>
          </div>
        </div>

        <template #footer>
          <div class="list-view-drawer__footer" v-if="itemSelected">
            <b-button size="sm" variant="outline-danger" block @click="remove(itemSelected)">
              <AppIcon name="delete" class="mr-1" /> Eliminar
            </b-button>
          </div>
        </template>
      </b-sidebar>

      <b-card body-class="py-2">
        <div class="list-view-footer">
          <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
            <AppIcon name="back" />
            Volver
          </b-button>

          <nav v-if="table.tablePaginate">
            <b-pagination class="mb-0"
                          size="sm"
                          pills
                          :total-rows="table.tablePaginate.total"
                          :per-page="table.tablePaginate.per_page"
                          v-model="table.currentPage"
                          @input="load()" />
          </nav>
        </div>
      </b-card>

      <!-- ########################### -->
      <!-- #####     MODALES     ##### -->
      <!-- ########################### -->

      <!-- CRUD MAIN -->
      <b-modal v-model="modal.form.active"
              :key="modal.form._id"
              :id="modal.form._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="location_on" /></span>
          <h5 class="app-modal-header__title">{{this.modal.form.title}}</h5>
        </div>

        <b-row>
          <b-col md="12">
            <b-form-group label="Nombre">
              <b-form-input type="text"
                            size="sm"
                            v-model="crud.form.name"
                            required
                            placeholder="Ingresar un nombre">
              </b-form-input>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <FindObject type="sellers"
                        @select-object="loadSellers($event)"
                        :valueID="crud.form.sellers_id"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.form.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="save()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>

      <!-- CRUD SUB -->
      <b-modal v-model="modal.formSub.active"
              :key="modal.formSub._id"
              :id="modal.formSub._id">
        <div slot="modal-header" class="app-modal-header">
          <span class="app-modal-header__icon"><AppIcon name="person_add" /></span>
          <h5 class="app-modal-header__title">{{this.modal.formSub.title}}</h5>
        </div>

        <div class="crud-zones-modal-context" v-if="itemSelected">
          <div><b>{{itemSelected.name}}</b></div>
          <small class="text-muted" v-if="itemSelected.seller">Vendedor: {{itemSelected.seller.name}}</small>
        </div>

        <b-row>
          <b-col md="12">
            <FindObject render="search"
                        type="customers"
                        @select-object="loadSellersCustomers($event)"
                        :valueID="crud.formSub.customers_id"
                        :where="conditionCustomersActive"/>
          </b-col>
        </b-row>

        <div slot="modal-footer">
          <b-button variant="outline-secondary" class="mr-1" @click="modal.formSub.active=false">Cancelar</b-button>
          <b-button variant="dark" @click="saveSub()"><AppIcon name="save" class="mr-1" /> Guardar</b-button>
        </div>
      </b-modal>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'
  import Param from '@/config/parameters'
  import Funciones from '@/handler/funciones'
  import StorageLocal from '@/handler/storageLocal'
  import TabHeaderActions from '@/components/inc/tabs/TabHeaderActions'

  export default {
    components: {
      FindObject,
      TabHeaderActions,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.VENDEDORES,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudZones',
          elements: {}
        },
        parameters: {
          codeCustomer: Helper.hasParametersAccess(Param.P2)
        },
        filtersOpen: false,
        isMobileViewport: false,
        itemSelected: null,
        detailDrawer: false,
        table : {
          items: [],
          fields: [],
          currentPage: 1,
          perPage: 0,
          isBusy: false,
          tablePaginate: null,
        },
        tableSub : {
          items: [],
          fields: [],
        },
        crud: {
          form: {
            id: 0,
            name: '',
            sellers_id: 0,
            sellers: null,
          },
          formSub: {
            id: 0,
            customers_id: 0,
            customers: null,
            zone_id: 0,
          },
        },
        modal: {
          form: {
            active: false,
            title: ''
          },
          formSub: {
            active: false,
            title: ''
          },
        },
        arr: {
          filters: {
            sellers: [],
            withCustomer: [
              {code:'all', label: 'Todos'},
              {code:true, label: 'Con Clientes'},
              {code:false, label: 'Sin Clientes'},
            ],
          }
        },
        filters: {
          name: '',
          sellers: 0,
          withCustomer: {code:'all', label: 'Todos'},
        }
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.loadFieldTable()
      this.setFieldTableCustomer()
      this.filterLoadSellers()

      // Acceso directo desde "Zonas" en el listado de vendedores: llega con
      // el vendedor a filtrar por query, no por preferencia guardada -- por
      // eso el panel se fuerza abierto en vez de respetar StorageLocal acá.
      if(this.$route.query.sellers_id) {
        this.filters.sellers = [{ code: Number(this.$route.query.sellers_id), label: this.$route.query.sellers_name || '' }]
        this.filtersOpen = true
      } else {
        this.filtersOpen = StorageLocal.getValue('filters_open_crud_zones') == 'true'
      }

      this.load()

      this.mobileMql = window.matchMedia('(max-width: 767.98px)')
      this.isMobileViewport = this.mobileMql.matches
      this.mobileMql.addEventListener('change', this.updateMobileViewport)
    },
    beforeDestroy() {
      if(this.mobileMql) {
        this.mobileMql.removeEventListener('change', this.updateMobileViewport)
      }
    },
    watch: {
      filtersOpen: function (value) {
        StorageLocal.setValue('filters_open_crud_zones', value ? 'true' : 'false')
      },
      isMobileViewport() {
        this.loadFieldTable()
        this.setFieldTableCustomer()
      },
    },
    computed: {
      conditionCustomersActive(){
        return [{field: 'active', condition: true}];
      },
      currentZoneIndex() {
        if(!this.itemSelected || !this.table.items) {
          return -1
        }
        return this.table.items.findIndex(i => i.id === this.itemSelected.id)
      },
      canGoPrevZone() {
        return this.currentZoneIndex > 0
      },
      canGoNextZone() {
        if(this.currentZoneIndex < 0) {
          return false
        }
        return this.currentZoneIndex < this.table.items.length - 1
      },
    },
    methods: {
      // RESPONSIVE
      updateMobileViewport(e) {
        this.isMobileViewport = e.matches
      },
      alignClass(desktopClass) {
        return this.isMobileViewport ? 'text-left' : desktopClass
      },
      avatarFromName(name) {
        return Funciones.avatarFromName(name)
      },
      confirmDialog(message, options) {
        var danger = !!options.danger
        var icon = options.icon || (danger ? 'warning' : 'help')
        var title = this.$createElement('span', { class: 'app-confirm-header__title' }, [
          this.$createElement('AppIcon', { props: { name: icon } }),
          options.title
        ])
        return this.$bvModal.msgBoxConfirm(message, {
          title: title,
          size: 'sm',
          buttonSize: 'sm',
          okVariant: danger ? 'danger' : 'dark',
          okTitle: options.okTitle,
          cancelTitle: options.cancelTitle || 'Cancelar',
          footerClass: 'p-2',
          headerClass: danger ? 'app-confirm-header app-confirm-header--danger' : 'app-confirm-header',
          hideHeaderClose: false,
          centered: true
        })
      },
      loadFieldTable() {
        this.table.fields = []
        this.table.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-center')})
        this.table.fields.push({key: 'name', label: 'Nombre', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'sellers_id', label: 'Vendedor', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'observations', label: 'Clientes', class: 'align-middle ' + this.alignClass('')})
        this.table.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width: '60px'})
      },
      setFieldTableCustomer() {
        this.tableSub.fields = []
        if(this.parameters.codeCustomer) {
          this.tableSub.fields.push({key: 'code', label: 'Código', sortable: true, class: 'align-middle ' + this.alignClass('text-left'), width:"50px"})
        } else {
          this.tableSub.fields.push({key: 'id', label: 'ID', sortable: true, class: 'align-middle ' + this.alignClass('text-left'), width:"50px"})
        }
        this.tableSub.fields.push({key: 'customers_id', label: 'Cliente', class: 'align-middle ' + this.alignClass('text-left'), width:"200px"})
        this.tableSub.fields.push({key: 'f_action', label: this.isMobileViewport ? 'Acción' : '', class: 'align-middle ' + this.alignClass('text-right'), width:"60px"})
      },
      getRowCount (items) {
        return items.length
      },
      onRowClicked(item, index, event) {
        if(!item) return

        if(event && event.target) {
          const ignoreTags = ['INPUT', 'BUTTON', 'A', 'SELECT', 'TEXTAREA', 'LABEL', 'SVG', 'PATH']
          if(ignoreTags.includes(event.target.tagName)) return
          if(event.target.closest('.dropdown')) return
        }

        this.openSub(item)
      },
      rowClass(item, type) {
        if(type !== 'row' || !item) return ''
        if(this.detailDrawer && this.itemSelected && item.id === this.itemSelected.id) {
          return 'app-table-row-active'
        }
        return ''
      },
      openSub(item) {
        this.itemSelected = item
        this.detailDrawer = true
        this.tableSub.items = []

        var result = serviceAPI.mostrarClienteZona(item.id)
        result.then((response) => {
          var data = response.data
          if(data) {
            this.tableSub.items = data
          }
        })
      },
      hideSub() {
        this.itemSelected = null
        this.tableSub.items = []
        this.detailDrawer = false
      },
      goPrevZone() {
        if(!this.canGoPrevZone) return
        var item = this.table.items[this.currentZoneIndex - 1]
        if(item) this.openSub(item)
      },
      goNextZone() {
        if(!this.canGoNextZone) return
        var item = this.table.items[this.currentZoneIndex + 1]
        if(item) this.openSub(item)
      },
      load(forceOpenSub=false) {
        this.table.isBusy = true
        var result = serviceAPI.filtrarZona(this.filters, this.table.currentPage)

        result.then((response) => {
          var data = response.data
          this.table.tablePaginate = data
          this.table.items = data.data
          this.table.isBusy = false

          if(forceOpenSub && this.itemSelected) {
            var updated = this.table.items.find(i => i.id === this.itemSelected.id)
            if(updated) {
              this.openSub(updated)
            }
          }
        })
        .catch(error => {
          this.table.isBusy = false
          this.$awn.alert(Error.showError(error))
        });
      },
      add() {
        this.crud.form.id = 0
        this.crud.form.name = ''
        this.crud.form.sellers_id = 0

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Nueva Zona"
        this.modal.form.active = true
      },
      edit(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name
        this.crud.form.sellers_id = item.sellers_id

        this.modal.form._id = Math.random().toString(36).slice(2, 8)
        this.modal.form.title = "Editar Zona"
        this.modal.form.active = true
      },
      remove(item) {
        this.crud.form.id = item.id
        this.crud.form.name = item.name

        this.confirmDialog('¿Desea borrar el item (' + this.crud.form.id + ') - '+ this.crud.form.name + '?', {
          title: 'Borrar Zona',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarZona(this.crud.form.id);

            result.then((response) => {
              if(this.itemSelected && this.itemSelected.id === item.id) {
                this.hideSub()
              }
              loader.hide()
              this.load()
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      save() {
        let loader = this.$loading.show();
        if (this.crud.form.id) {
          var result = serviceAPI.editarZona(this.crud.form);
        } else {
          var result = serviceAPI.agregarZona(this.crud.form);
        }

        result.then((response) => {
          this.modal.form.active = false
          loader.hide()
          this.load(true)
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },

      addSub(item) {
        this.crud.formSub.id = 0
        this.crud.formSub.customers_id = 0
        this.crud.formSub.zone_id = item.id

        this.modal.formSub._id = Math.random().toString(36).slice(2, 8)
        this.modal.formSub.title = "Asignar Clientes"
        this.modal.formSub.active = true
      },
      removeSub(item) {
        this.crud.formSub.id = item.id
        this.crud.formSub.customers = item.customer

        this.confirmDialog('¿Desea borrar el item (' + this.crud.formSub.customers.id + ') - '+ this.crud.formSub.customers.name + '?', {
          title: 'Quitar Cliente',
          icon: 'delete',
          danger: true,
          okTitle: 'SI',
          cancelTitle: 'NO'
        })
        .then(value => {
          if (value) {
            let loader = this.$loading.show();
            var result = serviceAPI.eliminarZonaCustomers(this.crud.formSub.id);

            result.then((response) => {
              this.modal.formSub.active = false
              loader.hide()
              this.load(true)
              this.$awn.success("Registro eliminado");
            })
            .catch(error => {
              loader.hide()
              this.$awn.alert(Error.showError(error));
            })
          }
        })
        .catch(error => {
          this.$awn.alert(Error.showError(error));
        })
      },
      saveSub() {
        let loader = this.$loading.show();
        if (this.crud.formSub.id) {
          var result = serviceAPI.editarZonaCustomers(this.crud.formSub);
        } else {
          var result = serviceAPI.agregarZonaCustomers(this.crud.formSub);
        }

        result.then((response) => {
          this.modal.formSub.active = false
          loader.hide()
          this.load(true)
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
      loadSellers (object) {
        if(object){
          this.crud.form.sellers = object
          this.crud.form.sellers_id = object.id
        } else {
          this.crud.form.sellers = null
          this.crud.form.sellers_id = 0
        }
      },
      loadSellersCustomers (object) {
        if(object){
          this.crud.formSub.customers = object
          this.crud.formSub.customers_id = object.id
        } else {
          this.crud.formSub.customers = null
          this.crud.formSub.customers_id = 0
        }
      },

      filterLoadSellers() {
        var result = serviceAPI.obtenerVendedor()
        result.then((response) => {
          var data = response.data

          this.arr.filters.sellers = []
          data.forEach(element => {
            this.arr.filters.sellers.push({ code: element.id, label: element.name })
          });
        })
      },
    }
  }
</script>
<style>
  .crud-zones-modal-context {
    margin: 0 0 12px;
    padding: 10px 12px;
    border: 1px solid var(--app-color-border);
    border-radius: 8px;
    background: var(--app-color-surface-subtle);
  }
  .btn.crud-zones-action-toggle-labeled {
    display: inline-flex !important;
    align-items: center;
    justify-content: flex-start;
    width: auto !important;
    height: auto !important;
    min-height: 0;
    padding: 0 !important;
    border: none !important;
    background: transparent !important;
    box-shadow: none !important;
    color: var(--app-color-text-secondary) !important;
    font-size: 13px;
    line-height: 1.15;
  }
  .btn.crud-zones-action-toggle-labeled:hover,
  .btn.crud-zones-action-toggle-labeled:focus {
    color: var(--app-color-primary) !important;
    text-decoration: underline;
  }
</style>
